import { Stack, Typography } from '@mui/material';
import { Button } from 'system/atoms';
import { TextBlock } from 'common/ui/TextBlock';
import { useDrawer } from 'services/drawer/hooks';

export const SMSLearnMoreDrawer: React.FC<{
  phoneCountryCode: string;
}> = ({ phoneCountryCode }) => {
  const { closeDrawer } = useDrawer();

  return (
    <Stack width="500px" gap="40px" pb="20px">
      <TextBlock variant="drawer" title="Using SMS" />
      <Typography variant="subtitle1">
        Make sure candidate phone numbers you contact have the same country code
        as yours (+{phoneCountryCode}).
        <br />
        <br /> Sending SMS messages to phone numbers with a different country
        code <b>will fail</b>.<br />
        <br /> If you wish to contact candidates in different countries, choose
        email instead.
      </Typography>
      <Stack direction="row">
        <Button variant="primary" onClick={() => closeDrawer()}>
          OK
        </Button>
      </Stack>
    </Stack>
  );
};
